import React from "react";

const ShippingDelivery = () => {
  return (
    <section id="h4-pricing" className="relative w-full overflow-hidden">
      <div className="w-full h4-pricing-wrapper pb-[6rem] md:pb-[8rem] max-md:pt-[120px] md:pt-[160px] pricing_section_bg">
        <div className="theme-container mx-auto">
          <div className="w-full">
            <div className="title-area w-full flex justify-center">
              <div className="flex flex-col items-center">
                <div className="py-0.5 px-5 bg-[#1D109E07] border-[#1D109E1e] border rounded-[30px] font-medium text-[#1D109E] mb-5">
                  <span>Shipping And Delivery Policy</span>
                </div>
                <div className="mb-[60px]">
                  <h2 className="text-main-black font-semibold text-24 sm:text-48 text-center max-w-[519px]">
                    Truvana OPD
                  </h2>
                </div>
              </div>
            </div>
            <div className="md:px-[100px]">
                <ul>
                  <li>
                    1. Service orders are fulfilled by our empaneled health
                    providers through their qualified technicians or
                    phlebotomist or staff.
                  </li>
                  <li>
                    2. Product orders are shipped through registered domestic
                    courier companies and /or speed post only.
                  </li>
                  <li>
                    3. Orders are shipped within 0-7 days or as per the delivery
                    date agreed at the time of order confirmation and delivering
                    of the shipment subject to Courier Company / post office
                    norms.
                  </li>
                  <li>
                    4. We are not liable for
                    any delay in delivery by the courier company / postal
                    authorities and only guarantees to hand over the consignment
                    to the courier company or postal authorities within 0-7 days
                    rom the date of the order and payment or as per the delivery
                    date agreed at the time of order confirmation.
                  </li>
                  <li>
                    5. Delivery of all orders will be to the address provided by
                    the buyer.
                  </li>
                  <li>
                    6. Delivery of our services will be confirmed on your mail
                    ID as specified during registration. For any issues in
                    utilizing our services you may contact our helpdesk on{" "}
                    <a href="tel:91" style={{ display: "inline" }}>
                    +91-9211226940
                    </a>{" "}
                    or{" "}
                    <a
                      href="mailto:"
                      style={{ display: "inline" }}
                    >
                      support@truvanaopd.com
                    </a>
                    .
                  </li>
                </ul>
            </div>
          </div>
        </div>
        <div className="shape-1 absolute left-40 top-96 z-10">
          <img src="assets/images/home-four/shape-1.webp" alt="" />
        </div>
        <div className="shape-2 absolute right-96 top-96 z-10">
          <img src="assets/images/home-four/shape-2.webp" alt="" />
        </div>
        <div className="shape-3 absolute left-96 top-[550px] z-10">
          <img src="assets/images/home-four/shape-3.webp" alt="" />
        </div>
        <div className="shape-4 absolute right-96 top-[550px] z-10">
          <img src="assets/images/home-four/shape-4.webp" alt="" />
        </div>
      </div>
    </section>
  );
};

export default ShippingDelivery;
